function formatCurrency(value) {
  return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function toUtcDate(iso) {
  if (!iso) return null;
  const s = String(iso).trim();
  if (s.includes('T') || s.includes('Z') || s.includes('+')) return new Date(s);
  return new Date(s.replace(' ', 'T') + 'Z');
}

function formatCreatedAtDetail(iso) {
  if (!iso) return '—';
  const d = toUtcDate(iso);
  if (!d) return '—';
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const MM = String(d.getMonth() + 1).padStart(2, '0');
  return `${hh}:${mm} - ${dd}/${MM}/${d.getFullYear()}`;
}

function mapLotStatus(lotStatus, approvalStatus, isTransmitted) {
  if (lotStatus === 'archived') return 'archived';
  if (isTransmitted) return 'transmitted';
  if (lotStatus === 'pending') return 'pending';
  if (approvalStatus === 'pending') return 'approval';
  if (approvalStatus === 'approved') return 'sent';
  if (approvalStatus === 'rejected') return 'rejected';
  if (lotStatus === 'needs_approval') return 'approval';
  if (lotStatus === 'processed') return 'sent';
  if (lotStatus === 'uploaded') return 'processing';
  return 'draft';
}

function mapLotsToBatches(lotsData, approvalsData) {
  const approvalByLot = new Map(approvalsData.map((a) => [a.lot_id, a]));
  return lotsData.map((item) => {
    const approval = approvalByLot.get(item.id);
    const isTransmitted = Boolean(item.transmitted_at);
    const templateLabel = (item.template_name && String(item.template_name).trim())
      || 'Folha Importada';
    const dueRaw = item.company_payments_min_payment_date;
    const dueLabel = dueRaw
      ? new Date(dueRaw).toLocaleDateString('pt-BR')
      : '—';

    const uploader = item.uploader;
    const createdByName = (uploader && (uploader.name || uploader.email)) || '—';
    const createdByActive = uploader?.status === 'active';

    return {
      id: `L-${item.id}`,
      companyId: Number(item.company_id || 0),
      createdById: Number(item.uploaded_by || 0),
      date: toUtcDate(item.created_at)?.toLocaleDateString('pt-BR') ?? '—',
      createdAtLabel: formatCreatedAtDetail(item.created_at),
      createdByName,
      createdByActive,
      dueDate: dueLabel,
      dueDateRaw: dueRaw || null,
      creditorNames: Array.isArray(item.list_creditor_names) ? item.list_creditor_names : [],
      ref: item.reference_month || '-',
      siengeDocumentId: item.list_sienge_document_id || null,
      identifiedLocal: Boolean(item.list_identified_local),
      identifiedSienge: Boolean(item.list_identified_sienge),
      file: item.source_file || '-',
      template: templateLabel,
      total: formatCurrency(item.total_amount),
      colab: item.items_count || 0,
      status: mapLotStatus(item.status, approval?.status, isTransmitted),
      diffs: 0,
      transmittedAt: item.transmitted_at || null,
      lotId: item.id,
      approvalId: approval?.id || null,
      requesterName: approval?.requester?.name || '-',
      paymentType: item.payment_type || 'mass',
    };
  });
}

export { mapLotsToBatches };
